import moment from 'moment';
import * as K from 'common/constants';

const SEARCH_FILE_BASE = 'search-results';
const POWER_QUERY_FILE_BASE = 'power-query-results';
const TIMESTAMP_FORMAT = 'YYYY-MM-DDTHH_mm_ss';

/**
 * Create a name for a file that downloaded results from a search or Power Query.
 *
 * @param format          download format, eg CSV
 * @param isPowerQuery    if true, results are for a Power Query
 * @param now             current time (for testing)
 *
 * @returns download filename
 */
export const getDownloadFilename = (format: K.DATA_FORMAT, isPowerQuery: boolean, now?: moment.Moment): string => {
  const base = isPowerQuery ? POWER_QUERY_FILE_BASE : SEARCH_FILE_BASE;
  const timestamp = moment(now).format(TIMESTAMP_FORMAT);
  const extension = K.DATA_FORMAT_EXTENSION[format];

  return `${base}_${timestamp}.${extension}`;
};
